---
title: "Terms and Conditions"
path: "/terms-and-conditions"
seoTitle: "Terms & Conditions | Dutch Passion Thailand"
seoDescription: "The terms and conditions covering orders, payment, delivery and returns when you buy Dutch Passion cannabis seeds in Thailand. Please read before ordering."
---

Index:

Article 1 – Definitions

Article 2 – The Entrepreneur’s identity

Article 3 – Applicability

Article 4 – The offer

Article 5 – The contract

Article 6 – Right of withdrawal

Article 7 – Obligations of the consumer during the reflection

Article 8 – Exercise of the right of withdrawal by the consumer and their cost

Article 9 – Obligations of the trader in case of withdrawal

Article 10 – Exclusion of right of withdrawal

Article 11 – The price

Article 12 – Compliance and Warranty extension

Article 13 – Delivery and implementation

Article 14 – Extended duration transactions: duration, termination and renewal

Article 15 – Payment

Article 16 – Complaints

Article 17 – Disputes

Article 18 – Shipping policy

Article 19 –  Cancellation policy

Article 20 – Return & Refund policy

Article 21 – Additional or different terms

Article 1 – Definitions

In these conditions apply:

- Additional agreement: an agreement whereby the consumer products, digital content and / or services acquired in connection with a distance contract and these goods, digital content and / or services are provided by the trader or by a third party on the basis of an arrangement between that third party and the trader;
- Grace period: The period within which the consumer can exercise his right of withdrawal;
- Consumer: the natural person who is acting for purposes relating to his trade, business, craft or profession;
- Day: calendar;
- Digital content means data which are produced and supplied in digital form;
- Duration agreement: an agreement which extends to the regular delivery of goods, services and / or digital content for a certain period;
- Durable medium: any device – including also e-mail – that the consumer or business that enables information addressed personally to him, store in a way that future consultation or use over a period appropriate to the target for which it was intended, and which allows the unchanged reproduction of the stored information possible;
- Right of withdrawal: the ability of the consumer to see within the waiting period of the contract;
- Entrepreneur: the natural or legal products, offer (access to) digital content and / or services to consumers;
- Distance contract means an agreement between the entrepreneur and the consumer is concluded in the framework of an organized system for distance selling of products, digital content and / or services, up to and including the conclusion of the agreement exclusively or partially used of one or more means of distance communication;
- Model withdrawal form: the European standard form in Annex I to these conditions for withdrawal;
- Technology for distance communication: means that can be used to conclude a contract without the consumer and trader have to be met simultaneously in the same space.

Article 2 – The Entrepreneur’s identity

Dutch Passion Thailand

Email: info@dutchpassion.co.th

Article 3 – Applicability

- These general conditions apply to every offer of the entrepreneur and any agreement reached at a distance between businesses and consumers.
- Before concluding a distance contract, the text of these general conditions made available to the consumer. If this is not reasonably possible, the trader will before concluding the distance contract, indicate how the general conditions for inspection at the trader’s premises and that they be sent free of charge as soon as possible at the request of the consumer.
- If the distance contract is concluded electronically, notwithstanding the previous paragraph and before the distance contract is concluded, the text of these terms and conditions will be made available electronically to the consumer in such a way that the consumer in a simple way can be stored on a durable medium. If this is not reasonably possible, before the distance contract is closed, will indicate where to be aware of the general conditions electronically and that they will be sent free of charge at the request of the consumer electronically or otherwise.
- In the event that besides these general conditions also specific product or service conditions apply, the second and third paragraph shall apply and the consumer in case of conflicting terms always rely on the applicable provision that is most favorable to him .

Article 4 – The offer

- If an offer has a limited duration or subject to conditions, this will be explicitly stated in the offer.
- The offer includes a complete and accurate description of the offered products, digital content and / or services. The description is sufficiently detailed to allow a proper assessment of the offer by the consumer. If the Entrepreneur makes use of pictures, they are truthful images of the products, services and / or digital content. Obvious mistakes or errors in the offer binding on the entrepreneur.
- Each offer contains such information that is clear to the consumer what rights and obligations are attached to accepting the offer.

Article 5 – The contract

- The agreement is subject to the provisions of paragraph 4, concluded at the time of the consumer accepts the offer and meet the corresponding conditions.
- If the consumer has accepted the offer electronically, the trader will immediately acknowledge electronic receipt of acceptance of the offer. Until receipt of this acceptance has not been confirmed by the operator, the consumer may rescind the contract.
- If the agreement is created electronically, the trader will take appropriate technical and organizational measures to protect the electronic transfer of data and he will ensure a secure web environment. If the consumer can pay electronically, the trader will take appropriate safety precautions.
- The entrepreneur can within the law – inform the consumer’s ability to meet its payment obligations, and of all those facts and factors that are important to a sound conclusion of the distance contract. If the operator under this investigation was justified in order not to enter into the agreement, he is entitled to refuse or to bind its implementation to special conditions an order or request.
- The entrepreneur will be due upon delivery of the product, service, or digital content to the consumer the following information in writing or in such a way that it can be stored in an accessible manner by the consumer on a durable medium to send:
- the address of the establishment of the business where consumers can lodge complaints;
- the conditions and how the consumer can exercise the right of withdrawal, or a clear statement regarding the exclusion of the right of withdrawal;
- information about guarantees and after sales service;
- the price including all taxes of the product, service, or digital content; in so far as applicable, the cost of delivery; and the method of payment, delivery or performance of the contract;
- the requirements for terminating the agreement if the agreement has a duration of more than one year or is indefinite;
- if the consumer has a right of withdrawal and the model withdrawal form.

In the event of an extended transaction is the provision in the previous paragraph applies only to the first delivery.

Article 6 – Right of withdrawal

There is no right of withdrawal and no cooling-off period on any product sold through this website. This is stated here, before any order is placed, and it applies to every product in the catalogue.

Cannabis seeds are a sealed agricultural product. Once a packet has left our control, neither its viability nor its provenance can be verified, which is the reason for the exclusion.

An order may still be changed or cancelled while it has not yet been dispatched — see Article 19. Once it has been dispatched it cannot be returned or refunded — see Article 20.

Nothing in this Article affects Article 12. If a product does not conform to what was ordered, or arrives damaged, contact us: that is a question of conformity, not of withdrawal.

Article 7 – Obligations of the consumer during the reflection

Not applicable. No reflection period is offered — see Article 6.

Article 8 – Exercise of the right of withdrawal by the consumer and their cost

Not applicable — see Article 6.

Article 9 – Obligations of the trader in case of withdrawal

Not applicable — see Article 6.

Article 10 – Exclusion of right of withdrawal

Every product sold through this website is excluded from any right of withdrawal, as stated in Article 6.

Article 11 – The price

- During the period mentioned, the prices of the products and / or services have not increased in the offer, except for price changes due to changes in VAT rates.
- Notwithstanding the preceding paragraph, the business products or services whose prices are subject to fluctuations in the financial market and where the entrepreneur has no control, at variable prices. These fluctuations and the fact that any price targets, are at the offer.
- Price increases within 3 months after the conclusion of the contract are only allowed if they result from legislation or regulations.
- Price increases from 3 months after the conclusion of the contract are only allowed if the trader has agreed and:

a. they are the result of legislation or regulations; or

b. the consumer has the right to terminate the agreement as of the date the increase takes effect.

- The prices in the supply of products or services include VAT.

Article 12 – Compliance Agreement and extended warranty

- The operator guarantees that the products and / or services meet the contract specifications stated in the offer, the reasonable requirements of reliability and / or usability and on the date of the conclusion of the agreement existing legal provisions and / or government regulations. If agreed, the entrepreneur also ensure that the product is suitable for other than normal use.
- By the trader, its supplier, manufacturer or importer extended warranty limited never the legal rights and claims that consumers can make under the contract against the trader apply if the employer has failed to fulfill its part of the agreement.
- Under additional guarantee means any undertaking by the trader, its supplier, importer or producer which it attributes to the consumer certain rights or claims beyond which it is legally required in case he failed to fulfill his part of the agreement .

Article 13 – Delivery and implementation

- The trader will take the greatest possible care when receiving and implementing orders for products and when assessing applications for the provision of services.
- The place of delivery is the address that the consumer made known to the trader.
- Subject to what is stated in article 4 of these terms and conditions, the company will accepted orders expeditiously but not later than within 30 days, unless a different delivery period is agreed. If delivery is delayed or if an order is not or only partially carried out, the consumer receives them within 30 days after placing the order. The consumer in this case the right to terminate the contract without penalty and be entitled to any compensation.
- After dissolution in accordance with the preceding paragraph, the operator the amount that consumers paid refund immediately.
- The risk of damage and / or loss of products rests upon the trader up to the moment of delivery to the consumer or a pre-designated and the entrepreneur announced representative, unless expressly agreed otherwise.

Article 14 – Extended duration transactions: duration, termination and renewal

Termination:

- The consumer may contract for an indefinite period, which extends to the regular delivery of products (including electricity) or services, at any time denounce the applicable termination rules and a notice of up to one month.
- The consumer may contract concluded for a definite period, which extends to the regular delivery of products (including electricity) or services, at any time at the end of the fixed-term, subject to the agreed termination rules and a notice of one month.
- Consumers can the agreements mentioned in the previous paragraphs:

– Cancel at any time and not be limited to termination at a particular time or in a given period;

– At least cancel the same way as they are concluded;

– Cancel at the same notice as the company has negotiated for itself.

Extension:

- A contract for a definite period, which extends to the regular delivery of products (including electricity) or services may not be automatically extended or renewed for a fixed period.
- Notwithstanding the preceding paragraph, an agreement is concluded for a definite period, which extends to the regular delivery of daily or weekly newspapers and magazines be tacitly renewed for a fixed period of up to three months if the consumer against this extended Agreement the end of the extension may terminate with notice not exceeding one month.
- A contract concluded for a definite period, which extends to the regular delivery of products or services may only be extended for an indefinite period if the consumer may at any time terminate with a notice of up to one month. The notice period is more than three months in case the agreement extends to the regular, but less than once a month, delivering daily, news and weekly newspapers and magazines.
- An agreement with limited duration of regular delivery of trial days, news and weekly newspapers and magazines (trial or introductory subscription) will be terminated automatically and not tacitly continued after the trial or introductory.

Duration:

- If a contract has a duration of more than one year, the consumer after a year may withdraw at any time terminate with a notice of up to one month, unless the reasonableness and fairness against termination before the end of the agreed object duration.

Article 15 – Payment

- Unless otherwise specified in the contract or additional conditions should the amounts owed by the consumer to be paid within 14 days after the start of the cooling-off period, or in the absence of a cooling-off period within 14 days after the conclusion of the agreement. In case of an agreement to provide a service, this period starts on the day after the consumer has received the confirmation of the agreement.
- When selling products to consumers, consumers in general conditions may never be obliged to make a prepayment of more than 50%. If payment is agreed, the consumer may not assert any rights regarding the implementation of the order or service (s) before the advance payment has been made.
- The consumer has the duty to inaccuracies in data supplied or specified payment immediately to the operator.

Article 16 – Complaints

- The entrepreneur has a well-publicized complaints and deals with complaints under this procedure.
- Complaints about the execution of the contract must within a reasonable time after the consumer the defects, fully and clearly described and submitted to the entrepreneur.
- When the trader complaints within a period of 14 days from the date of receipt. If a complaint is a foreseeable longer processing time, then answered by the operator within the period of 14 days with a notice of receipt and an indication if the consumer can expect a more detailed answer.
- If the complaint or within a reasonable time or within three months after the filing of the complaint can be resolved by mutual agreement creates a dispute that is subject to dispute.

Article 17 – Disputes

- On agreements between the entrepreneur and the consumer of these terms refer only to Thailand law.

Article 18 – Shipping policy

Shipping only in Thailand. Orders placed before 15:00 on a working day are dispatched the same day. Standard postal delivery costs 100 THB anywhere in Thailand, Bangkok included, and normally arrives within 1 to 3 business days. Within Bangkok, same-day delivery is available as an additional option for 250 THB.

Article 19 – Cancellation policy

An order can be changed or cancelled while it has not yet been dispatched. Contact us with your order number as soon as possible: orders placed before 15:00 on a working day are dispatched the same day, so the window is short. Once an order has been dispatched it can no longer be cancelled.

Article 20 – Return & Refund policy

No product purchased through this website may be returned, and no refund is given for a returned product. Article 6 excludes any right of withdrawal; Article 19 covers changing or cancelling an order before it is dispatched. This does not affect Article 12: if a product does not conform to what was ordered, or arrives damaged, contact us.

Article 21 – Additional or different terms

Additional or different provisions of these terms may not be to the detriment of consumers and should be recorded in writing or may be in such a way that the consumer in an accessible manner stored on a durable medium.

International shipping is not allowed.
